module.exports = __webpack_public_path__ + "static/media/tagsGo.e7d95828.svg";